import { render, staticRenderFns } from "./EventBitrate.vue?vue&type=template&id=7f2e58a8&"
import script from "./EventBitrate.vue?vue&type=script&lang=js&"
export * from "./EventBitrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1751410358/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f2e58a8')) {
      api.createRecord('7f2e58a8', component.options)
    } else {
      api.reload('7f2e58a8', component.options)
    }
    module.hot.accept("./EventBitrate.vue?vue&type=template&id=7f2e58a8&", function () {
      api.rerender('7f2e58a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Events/EventBitrate.vue"
export default component.exports